import { Component, input, output } from '@angular/core';
import { CdkMenuItem } from '@angular/cdk/menu';
import {
  ButtonDirective,
  CuiDropdownComponent,
  CuiDropdownTriggerDirective,
} from '@innersource/common-ui-components';
import { ToolJob } from '../../../../utils/models/tool.models';

@Component({
  selector: 'app-tool-node',
  templateUrl: './tool-node.component.html',
  styleUrls: ['./tool-node.component.scss'],
  imports: [ButtonDirective, CdkMenuItem, CuiDropdownComponent, CuiDropdownTriggerDirective],
})
export class ToolNodeComponent {
  /** Inputs. */
  readonly job = input<ToolJob>();
  readonly name = input.required<string>();
  readonly waitingForTool = input(false);
  readonly rerunStep = input<() => Promise<void>>();

  /** Outputs. */
  readonly logsRequested = output<number>();

  /** Formats a job's elapsed duration. */
  duration(job: ToolJob): string {
    if (!job.started) return '-';
    const start = new Date(job.started).getTime();
    const end =
      job.status === 'Done' || job.status === 'Error' ? new Date(job.modified) : new Date();
    const elapsedSeconds = Math.max(0, Math.floor((end.getTime() - start) / 1000));
    return this.formatDuration(elapsedSeconds);
  }

  /** Formats elapsed seconds for display. */
  private formatDuration(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    if (hours) return `${hours}h ${minutes}m`;
    if (minutes) return `${minutes}m ${seconds % 60}s`;
    return `${seconds}s`;
  }
}
